'use strict';
module.exports = ([function () {
        return function (clazz) {
            var ret = "";
            if (clazz) {
                var array = clazz.split('.');

                if (array.length > 0) {
                    ret = array[array.length - 1].toLowerCase();
                }
            }
            return ret;
        };
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/clazzIconFilter.js
// module id = 278
// module chunks = 0